(function () {
  const modalOpenButtons = document.querySelectorAll('[data-modal-open]')

  modalOpenButtons.forEach((button) => {
    button.addEventListener('click', (e) => {
      // open modal & lock body scroll
      const modal = document.querySelector('[data-modal-container][data-modal-id='+e.target.dataset.modalId+']')
      modal.classList.remove('hidden')
      document.body.classList.add('lock-scroll')
      // if mobile scroll to bottom of modal
      const viewportWidth = window.innerWidth || document.documentElement.clientWidth;
      if (viewportWidth <= 768) {
        window.setTimeout(function() {
          modal.scrollTo(0, modal.scrollHeight)
        }, 100)
      }
      // setup close buttons
      const modalCloseButtons = modal.querySelectorAll('[data-modal-close]')
      modalCloseButtons.forEach((e) => {
        e.addEventListener('click', (e) => {
          modal.classList.add('hidden')
          document.body.classList.remove('lock-scroll')
        })
      })
    })
  })
})();